<template>
    <b-form-group :invalid-feedback="invalidFeedback" :label="label" :label-for="formControlId" v-bind="$attrs">
        <csp-form-select-searchable
            :id="formControlId"
            v-model="data[property]"
            :allow-empty="!isRequiredProperty"
            :auto-select-single-option="autoSelectSingleOption"
            :default-value="defaultValue"
            :disable-change-trigger="disableChangeTrigger"
            :disabled="isReadOnlyProperty || dependencyDisabled"
            :open-direction="openDirection"
            :options="internalOptions"
            :options-loader="optionsLoader"
            :placeholder="placeholder"
            :property="property"
            :reset-after="resetAfter"
            :state="validationState"
            :value-empty="valueEmpty"
            @change="handleSelect"/>
    </b-form-group>
</template>

<script>
    import FormGroupMixin from './FormGroupMixin';
    import SelectSearchable from './SelectSearchable';
    import LazySelectOptionsMixin from './mixins/LazySelectOptionsMixin';
    import DependentSelectMixin from '@components/form/mixins/DependentSelectMixin'

    export default {
        name: 'FormGroupSelectSearchable',
        components: {
            'csp-form-select-searchable': SelectSearchable,
        },
        mixins: [FormGroupMixin, LazySelectOptionsMixin, DependentSelectMixin],
        props: {
            openDirection: {
                type: String,
                default: '',
            },
            valueEmpty: {
                type: null,
                default: null,
            },
            disableChangeTrigger: {
                type: Boolean,
                default: false,
            },
            autoSelectSingleOption: {
                type: Boolean,
                default: false,
            },
            resetAfter: {
                type: Boolean,
                default: false,
            },
            defaultValue: {
                type: [String, Number, null],
                default: null,
            },
        },
        emits: ['change', 'changeOption'],
        computed: {
            placeholder() {
                if (this.hideLabel) {
                    return this.labelTranslation;
                }
                if (this.overridePlaceholder) {
                    return this.overridePlaceholder;
                }
                return this.$t('form.multiselect.placeholder');
            },
        },
        methods: {
            handleSelect(option) {
                this.form.setProperty(this.property, option ? option.value : null);
                this.$emit('change', option ? option.value : null);
                this.$emit('changeOption', option);
            },
        },
    }
</script>
